import { render, staticRenderFns } from "./annotation-list-item.vue?vue&type=template&id=469f4133&"
import script from "./annotation-list-item.vue?vue&type=script&lang=js&"
export * from "./annotation-list-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports